<template>
  <b-card no-body class="port-calls-stat w-100">
    <div slot="header">
      Port Calls by Country
    </div>
    <b-card-body>
      <div v-if="isEmpty" class="text-center">
        No data available
      </div>
      <div v-else>
        <div class="text-center mb-4">
          <buttons-select :choices="startDate.choices" v-model="startDate.value" />
        </div>

        <bar-chart :items="callsFormatted" maxHeight="270px" />
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import countBy from 'lodash-es/countBy'
import orderBy from 'lodash-es/orderBy'
import isEmpty from 'lodash-es/isEmpty'
import moment from 'moment'
import { countries } from 'countries-list'
import BarChart from '@/components/widgets/BarChart'
import ButtonsSelect from '@/components/widgets/ButtonsSelect'

export default {
  name: 'port-calls-stat',

  components: {
    ButtonsSelect,
    BarChart,
  },

  props: {
    portCalls: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    const allTimeValue = moment().subtract(20, 'years').format('YYYY-MM-DD');

    return {
      startDate: {
        choices: [
          {text: 'Last 12 months', value: moment().subtract(1, 'years').format('YYYY-MM-DD')},
          {text: 'Last 24 months', value: moment().subtract(2, 'years').format('YYYY-MM-DD')},
          {text: 'All time', value: allTimeValue},
        ],

        value: allTimeValue,
      },
    };
  },

  methods: {},

  computed: {
    filteredPortCalls() {
      return this.portCalls.filter(item => {
        return moment(item.arrivedAt) > moment(this.startDate.value)
      });
    },

    callsCounted() {
      if(this.isEmpty) {
        return [];
      }

      let counts = countBy(this.filteredPortCalls, 'countryCode');
      counts = Object.keys(counts).map(countryCode => {
        return {
          code: countryCode,
          count: counts[countryCode],
          countryData: countries[countryCode.toUpperCase()] || {},
        };
      });
      return orderBy(counts, ['count'], ['desc']);
    },

    callsFormatted() {
      return this.callsCounted.map(item => ({
        title: `${item.countryData.emoji} ${item.countryData.name}`,
        volume: item.count,
      }));
    },

    isEmpty: function() {
      return isEmpty(this.portCalls);
    },
  },
};
</script>

<style lang="scss" scoped>
.port-calls-stat {
  min-height: 418px;
}

.stats {
  list-style: none;
  padding: 0;

  li {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    border-bottom: 1px solid gray;
    padding-bottom: 5px;
    margin-bottom: 20px;
    p:first-child {
      color: white;
      font-weight: 600;
    }
  }
  p {
    margin: 0;
  }
}
</style>
